import styled from 'styled-components'

import ShareButton from 'components/molecules/ShareButton'

const Share = styled(ShareButton)`
  z-index: 1;
`
export default Share
